import { render, staticRenderFns } from "./Cancellation.vue?vue&type=template&id=eff67a3a&scoped=true"
import script from "./Cancellation.vue?vue&type=script&lang=js"
export * from "./Cancellation.vue?vue&type=script&lang=js"
import style0 from "./Cancellation.vue?vue&type=style&index=0&id=eff67a3a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff67a3a",
  null
  
)

export default component.exports